import {IModalHelper, ModalHelper} from "../../helpers/utils/modalhelper";
import {ParentView} from "../parentView";
import {EventTypes} from "../../helpers/eventtypes";


class RegisterView extends ParentView {
    LnkPasswordTips: string;
    PasswordTipUrl: string;
    modalHelper: IModalHelper;
    constructor(formId: string, btnSaveId: string) {
        super(formId, btnSaveId);
        this.LnkPasswordTips = "lnkPasswordTips";
        this.PasswordTipUrl = "";
        this.modalHelper = new ModalHelper(this.constants.AppVariables.ModalDivId);
        //
    }

    AddPasswordToggleEvents(): void {
        const toggles = document.querySelectorAll("[data-password-toggle]");
        toggles.forEach(toggle => {
            toggle.addEventListener("click", () => {
                const targetId = toggle.getAttribute("data-target-id");
                if (!targetId) {
                    return;
                }
                const targetInput = document.getElementById(targetId) as HTMLInputElement;
                if (!targetInput) {
                    return;
                }
                const isMasked = targetInput.type === "password";
                targetInput.type = isMasked ? "text" : "password";

                // Toggle the eye icon
                const icon = toggle.querySelector("i");
                if (icon) {
                    icon.classList.toggle("fa-eye", !isMasked);
                    icon.classList.toggle("fa-eye-slash", isMasked);
                }

                toggle.setAttribute("aria-label", isMasked ? "Hide password" : "Show password");
                toggle.setAttribute("aria-pressed", isMasked ? "true" : "false");
            });
        });
    }

    InitView(): void {
        //this.utility.hideDiv("spinner");
        let lnkTips: HTMLAnchorElement = <HTMLAnchorElement>(document.getElementById(this.LnkPasswordTips) as HTMLAnchorElement );
        if (lnkTips) {
            let obj = this;
            //console.log(obj)
            lnkTips!.addEventListener("click", function (event) {
                event.preventDefault(); 
                let url = `${lnkTips.href}`;
                //obj.utility.sayToast(url);
                obj.modalHelper.showPopUp(url); 
            });
        } 
        //Add Button Click Event 
        this.AddSaveButtonClickForValidation();
        this.AddPasswordToggleEvents();
    }


}
export { RegisterView }

/* add Listener - handle both cases: DOMContentLoaded already fired or not yet */
function initRegisterView() {
    //console.log('RegisterView: Initializing');
    let obj: RegisterView = new RegisterView("register-form", "lnkRegister");  
    //console.log('RegisterView: Created, calling InitView');
    obj.InitView();
    //console.log('RegisterView: InitView completed');
}

// Check if DOM is already loaded
if (document.readyState === 'loading') {
    //console.log('RegisterView: DOM still loading, adding DOMContentLoaded listener');
    document.addEventListener(EventTypes.DOMContentLoaded, initRegisterView);
} else {
    //console.log('RegisterView: DOM already loaded, initializing immediately');
    initRegisterView();
}
